<template>
  <div class="row servicesdetail">
    <div class="col-md-6 col-12">
      <img src="https://cdn.proxyscrape.com/img/service_icons-02.svg?v=3" alt="" />
    </div>
    <div class="col-md-6 col-12 d-flex align-items-center">
      <div>
        <h2><span class="proxynumber">40k+</span><br />Datacenter proxy pool</h2>
        <p>
          Thanks to the enormous growth, ProxyScrape can host its own dedicated proxy pool. By
          pooling its customers together, we make sure you get
          <strong>the best datacenter proxies</strong> at an affordable price.
        </p>
        <div class="row">
          <div class="col-xl-5 col-12">
            <router-link class="btn w-100" to="/premium?ref=home">Learn more</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12 d-md-none d-block">
      <img src="https://cdn.proxyscrape.com/img/service_icons-01.svg?v=3" alt="" />
    </div>
    <div class="col-md-6 col-12 d-flex align-items-center">
      <div>
        <h2>7 million residential proxies</h2>
        <p>
          Residential proxies are the perfect alternative to other proxy variants when your target
          quickly bans you or when you need proxies from a specific location. With the 7 million
          ProxyScrape residential proxies, you are sure to get the best possible results.
        </p>
        <div class="row">
          <div class="col-xl-5 col-12">
            <router-link class="btn w-100" to="/residential?ref=home">Learn more </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6 col-12 d-md-block d-none">
      <img src="https://cdn.proxyscrape.com/img/service_icons-01.svg?v=3" alt="" />
    </div>
    <div class="col-md-6 col-12">
      <img src="https://cdn.proxyscrape.com/img/service_icons-03.svg?v=3" alt="" />
    </div>
    <div class="col-md-6 col-12 d-flex align-items-center">
      <div>
        <h2>Dedicated proxies</h2>
        <p>
          Proxies that are only used by you with an internet speed of 1GBPs and unlimited bandwidth.
          Do you need proxies that you only use to ensure the best possible quality? Then dedicated
          proxies is the best choice!
        </p>
        <div class="row">
          <div class="col-xl-5 col-12">
            <router-link class="btn w-100" to="/dedicated?ref=home"> Learn more </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped src="../../assets/css/home.css"></style>
